// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"1":"606f384a","284":"28d5b8da","498":"3906ceee","574":"077407b7","633":"4e5914b0","694":"29ff0485","699":"e6f8ec23","748":"f49ffe5e","790":"6f6f4037","822":"edd196ce","908":"3a7c25a7","926":"a48bcbd0","971":"f33b2ea9"}[chunkId] + ".js";
};